// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/forced-landing-site-pattern.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/forced-landing-site-pattern/forced-landing-site-pattern.js';

mount([g0]);
